import * as React from 'react'
import { FC } from 'react'
import { Formik } from 'formik'
import { TopSearch } from './TopSearch'
import { useGetRecentSearches } from '@user/store/globalSearch/hooks/useGetRecentSearches'
import { useGetCustomizedResultsSettings } from '@user/store/globalSearch/hooks/useGetCustomizeResultsSettings'
import { OnSearchAddressClick } from '../ResultItem/typings'

interface Props {
  onClose?: () => void
  topSearch: string
  onCustomizeDrawerOpen: (search: string) => void
  onSearchAddressClick?: OnSearchAddressClick
}

export const TopSearchContainer: FC<Props> = (props) => {
  const { topSearch } = props
  useGetRecentSearches()
  useGetCustomizedResultsSettings()

  return (
    <Formik onSubmit={() => {}} initialValues={{ topSearch }}>
      <TopSearch {...props} />
    </Formik>
  )
}
